<script setup lang="ts">
import PickOrganizationMenu from '@/components/organizations/PickOrganizationMenu.vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
</script>

<template>
    <v-fade-transition appear>
        <v-row class="d-flex justify-center">
            <div class="v-col-lg-6" v-if="authStore.accessibleOrganizations">
                <div>
                    <p class="mb-3">Gebruik het onderstaande menu om te wisselen van bedrijf.</p>
                    <PickOrganizationMenu />
                </div>
            </div>
            <div v-else class="d-flex justify-center align-center ga-3 flex-column warning-holder">
                <v-icon icon="warning" class="warning-icon" />
                <p><span class="font-weight-black">Oh oh</span>, het lijkt erop dat je nog niet bent gekoppeld aan een bedrijf.</p>
                <p class="mt-5 text-center">Neem contact op met je werkomgever om toegang te krijgen tot een bedrijf.</p>
            </div>
        </v-row>
    </v-fade-transition>
</template>

<style scoped>
.warning-holder p {
    font-size: 18px;
}

.warning-icon {
    font-size: 85px;
}
</style>
